import { SpeciesData } from '../catch-table-models/species-data.model';
import { ValidationService } from '../../services/validation.service';
import { ProductType } from '../catch-table-models/product-type.model';
import { LandingSite } from '../landing-site.model';
import { ManagementArea } from '../area-models/management-area.model';
import { Subarea } from '../area-models/subarea.model';
import { SharedMethodsService } from 'src/app/services/shared-methods.service';
import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz-', 21);

export class OffloadReport {

  offloadDate: Date = new Date(); // date and time provided by the user

  landingSite: LandingSite = new LandingSite(); // where they landed

  productType: ProductType = new ProductType(); // the way the fish was processed

  lastMgmtArea: ManagementArea = new ManagementArea(); // last management area fished

  lastSubarea: Subarea = new Subarea(); // last subarea fished

  numDaysFished: string = '';

  firstDateFished: Date = new Date(); // first date fished for the offloaded catch

  lastDateFished: Date = new Date(); // last date fished for the offloaded catch

  fishSlip: string = ''; // yes/no answer

  fishSlipNumber: string = ''; // may not always be provided

  catchWeightUnits: string = ''; // only needed for Seine

  speciesDataList: SpeciesData[] = []; // offload data - list of species and their associated weight/pieces

  comments: string = ''; // optional

  reportID: string = '';

  internalId: string = '';

  confirmationNumber: string = 'Incomplete';

  emailedAt: string = ''; // written by the backend when the report email is actually sent; suppresses duplicate sends

  completionDate: Date = new Date(); // date the report was completed within the app

  submissionDate: Date = new Date(); // date the report was submitted to DFO (only accurate if 'isSubmitted'=true)

  /* Flags for programmatical use */

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  isComplete: boolean = false; // flag that tells us if the report has been completed


  lastUpdate: Date = new Date();

  constructor() {

    this.internalId = 'id-' + nanoid();
    this.reportID = SharedMethodsService.generateReportID("O");

  }

  public toString(): string {
    return 'Offload Date: ' + this.offloadDate + '; Confirmation Number: ' + this.confirmationNumber;
  }

  // check if the user's Offload Reports are defined
  public static transformAnonymous(offloadReports: any): OffloadReport[] {

    // if it is not defined, set a new one
    if (!offloadReports) {
      return [];
    }

    let userOffloadReports: OffloadReport[] = [];
    for (let offloadReport of offloadReports) {
      let userOffloadReport: OffloadReport = new OffloadReport();
      userOffloadReport.offloadDate = ValidationService.validateDate(offloadReport.offloadDate);
      userOffloadReport.landingSite = LandingSite.transformAnonymous(offloadReport.landingSite);
      userOffloadReport.productType = ProductType.transformAnonymous(offloadReport.productType);
      userOffloadReport.lastMgmtArea = ManagementArea.transformAnonymous(offloadReport.lastMgmtArea);
      userOffloadReport.lastSubarea = Subarea.transformAnonymous(offloadReport.lastSubarea);
      userOffloadReport.numDaysFished = offloadReport.numDaysFished ?? '';
      userOffloadReport.firstDateFished = ValidationService.validateDate(offloadReport.firstDateFished);
      userOffloadReport.lastDateFished = ValidationService.validateDate(offloadReport.lastDateFished);
      userOffloadReport.fishSlip = offloadReport.fishSlip ?? '';
      userOffloadReport.fishSlipNumber = offloadReport.fishSlipNumber ?? '';
      userOffloadReport.catchWeightUnits = offloadReport.catchWeightUnits ?? '';
      userOffloadReport.speciesDataList = SpeciesData.transformAnonArray(offloadReport.speciesDataList);
      userOffloadReport.comments = offloadReport.comments ?? '';
      userOffloadReport.reportID = offloadReport.reportID;
      userOffloadReport.internalId = offloadReport.internalId;
      userOffloadReport.confirmationNumber = offloadReport.confirmationNumber ?? '';
      userOffloadReport.emailedAt = offloadReport.emailedAt ?? '';
      userOffloadReport.completionDate = ValidationService.validateDate(offloadReport.completionDate);
      userOffloadReport.submissionDate = ValidationService.validateDate(offloadReport.submissionDate);
      userOffloadReport.isSubmitted = offloadReport.isSubmitted ?? false;
      userOffloadReport.lastUpdate = offloadReport.lastUpdate ?? new Date();
      userOffloadReport.isComplete = offloadReport.isComplete ?? false;
      userOffloadReports.push(userOffloadReport);
    }
    return userOffloadReports;

  }
}
